<script setup lang="ts">
import type GiftTemplate from '@consumer/types/GiftTemplate'
import newMiscMpStars4Icon from '@consumer/assets/icons/new-misc/mp-stars-4.svg?svgicon'
import { usePrimaryPlace } from './composables'

withDefaults(defineProps<{
  gift: GiftTemplate
}>(), {  })

const primaryPlace = usePrimaryPlace()
const placeCount = computed(() => __props.gift.places?.length ?? 1)
</script>

<template>
  <GMessage
    v-if="primaryPlace"
    backgroundColor="#F3F9FF"
    color="#111E36"
    :style="{
      boxShadow: '0px 0px 15px 0px rgba(0, 0, 0, 0.15)'
    }"
    class="!border-none rounded-v2md"
  >
    <div class="space-y-3">
      <div class="flex justify-start">
        <div
          class="
          flex items-center justify-center gap-2 w-auto text-xs font-semibold
          bg-white p-1.5 rounded-md
        "
        >
          Multi-Place
          <GIcon :svg="newMiscMpStars4Icon"/>
        </div>
      </div>
      <div class="text-lg lg:text-2xl !leading-tight font-semibold">
        Enjoy at {{ primaryPlace.name }}
        <span v-if="placeCount > 1">
          + {{ placeCount - 1 }} other places!
        </span>
      </div>

      <div class="text-base">
        With this multi-place gift, treat your recipient to {{ primaryPlace.name }}
        <span v-if="placeCount > 1">plus {{ placeCount - 1 }} other similar businesses</span>,
        all in one gift.
      </div>
    </div>
  </GMessage>
</template>
